import React from "react";
import ReactDOM from "react-dom";
import App from "src/App";
// PrimeIcons — өмнө нь index.html-ээс https://unpkg.com/primeicons/... гэж
// ГАДНЫ CDN-ээс татагдаж байсан. Тэр нь render-blocking stylesheet тул unpkg
// удаан/хаалттай үед бүх хуудас зогсдог байв. node_modules-д аль хэдийн
// байгаа тул bundle дотор оруулав — гадны сүлжээнээс хамаарахгүй боллоо.
import "primeicons/primeicons.css";
import "src/index.css";
// Бүх хуудасны мэдээллийн хайрцаг (antd Alert) — НЭГ жижиг хэмжээтэй
import "src/components/compactAlert.css";
// Системийн НЭГДСЭН хэмжээ (хүснэгт, товч, гарчиг, хуудаслалт)
import "src/hseStandard.css";

ReactDOM.render(<App />, document.getElementById("root"));
